import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-risk-analysis',
  templateUrl: './customer-risk-analysis.component.html',
  styleUrls: ['./customer-risk-analysis.component.css']
})
export class CustomerRiskAnalysisComponent implements OnInit {

  title="Risk Analysis";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/customer-risk-analysis/customer-risk-analysis.component.ts